const Entities = {
  CUSTOMER: "customer",
  EMPLOYEE: "employee",
  GROUP: "group",
  PRODUCT: "product",
  MENU: "menu",
  MenuSupplier: "menuSupplier",
  MenuFlight: "menuFlight",
  ITEM: "item",
  ONLINESTOREGROUP: "onlineStoreGroup",
  ORDER: "order",
  ORGANIZATION: "organization",
  MSOGROUP: "msoGroup",
  MSOSUPPLIER: "msoSupplier",
  MSOPRODUCT: "msoProduct",
  MSOMenu: "msoMenu",
  MSOMenuSupplier: "menuMsoSupplier",
  MSOCHARTOFACCOUNT: "msoChartOfAccount",
  CHARTOFACCOUNT: "chartOfAccount",
  STATECATEGORYTYPE: "stateCategoryType",
  STATEUNITOFMEASURE: "stateUnitOfMeasure",
  DFINVENTORYTYPE: "dfInventoryType",
  PURCHASEORDER: "purchaseOrder",
  ROOM: "room",
  SPECIALPRICING: "specialPricing",
  STORE: "store",
  SUPPLIER: "supplier",
  SUPPLIERAGENT: "supplierAgent",
  GIFTCARD: "giftCard",
  CREDITMEMO: "creditMemo",
  COUPON: "coupon",
  MSOCOUPON: "msoCoupon",
  PAYMENT: "payment",
  TAXSETUP: "taxSetup",
  STATEINVENTORY: "stateInventory",
  QUEUE: "queue",
  FLIGHT: "flight",
  JOURNAL: "journal",
  TIMESHEET: "timeSheet",
  RETURNITEM: "returnItem",
  FULLFILLMENT: "fulfillment",
  CASHRECONCILIATION: "cashReconciliation",
  INVENTORYCOUNT: "inventoryCount",
  BRAND: "brand",
  REPORTSETTINGS: "reportSettings",
  STRAIN: "strain",
  STORETAG: "storeTag",
};

module.exports = Entities;
